import { FC, useMemo } from 'react'
import { Box, Flex } from '@chakra-ui/react'

import { DynamicTextsByType } from 'components'

type Props = {
  values: any
  metadata: any
  metadanaFieldName?: string
}

const MetadatasValues: FC<Props> = ({ values, metadata }) => {
  const metadatasWithValuesInArray = useMemo(() => {
    const maxMetadataFieldsOnArray = [1, 2, 3, 4, 5, 6, 7]
    return maxMetadataFieldsOnArray.filter((number) => {
      const filterValue = values[`info_${number}`]
      return filterValue
    })
  }, [metadata, values])

  if (!metadata.name) return null

  return (
    <Box minWidth="100%" mt={metadatasWithValuesInArray.length > 0 ? 4 : 0}>
      <Flex direction="column" align="flex-start" gap={2}>
        {metadata.name &&
          metadatasWithValuesInArray.map((number) => {
            const label = metadata[`info_${number}_label`]
            const type = metadata[`info_${number}_data_type`]
            const filterValue = values[`info_${number}`]

            if (!label) return null
            if (!filterValue) return null

            return <DynamicTextsByType key={number} type={type} label={label} value={filterValue} />
          })}
      </Flex>
    </Box>
  )
}

export default MetadatasValues
